import type { ReactNode } from 'react'

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@ui/web/components'

export interface FaqItem {
  id: string
  question: string
  answer: ReactNode
}

interface FaqProps {
  items: FaqItem[]
  /** Controlled open item ids, e.g. when a button elsewhere opens one. */
  value?: string[]
  onValueChange?: (value: string[]) => void
}

export function Faq({ items, value, onValueChange }: FaqProps) {
  return (
    <Accordion
      className='w-full max-w-200'
      value={value}
      onValueChange={onValueChange ? (next) => onValueChange(next as string[]) : undefined}
    >
      {items.map((item) => (
        <AccordionItem key={item.id} value={item.id} id={`faq-${item.id}`}>
          <AccordionTrigger>{item.question}</AccordionTrigger>
          <AccordionContent>{item.answer}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  )
}
